/*
 * FX items in the skins catalog (backend ENG-815, frontend ENG-816): vibe sets
 * and boost animations sold, owned and equipped like skins. Each is a catalog
 * row (`SkinsSkin`) of type `vibe_set` or `boost_animation`, the type also
 * being its equip slot, with `fxPackageId` naming the SongShake FX package it
 * plays (a `vibe` package for a vibe set, a `boost` package for a boost
 * animation) and `assets` `{}`.
 *
 * In `GET /public/skins` (and the shelf's `locked` list) an FX item's payload
 * is in `vibeSet` / `boostAnimation` instead of `skin`. Every listener owns the
 * two free defaults (SongShake Classic and SongShake Boost, source
 * `default`); they are never for sale.
 */

/** The FX item types, which are also their equip slots. */
export const FX_ITEM_TYPES = Object.freeze(['vibe_set', 'boost_animation']);

/** The FX package type each item type plays. */
export const FX_PACKAGE_TYPE = Object.freeze({ vibe_set: 'vibe', boost_animation: 'boost' });

/** The `SkinShopItem` field that carries each item type's payload. */
export const FX_ITEM_FIELD = Object.freeze({ vibe_set: 'vibeSet', boost_animation: 'boostAnimation' });

/** The locale key segment of each item type (`stream.fxItem.type.*`). */
export const FX_ITEM_KEY = Object.freeze({ vibe_set: 'vibeSet', boost_animation: 'boostAnimation' });

/** Whether `type` is an FX item type. */
export const isFxItemType = (type) => FX_ITEM_TYPES.includes(type);

/** Whether a normalized `SkinsSkin` is an FX item that names its package. */
export const isFxSkin = (skin) => Boolean(skin && isFxItemType(skin.type) && typeof skin.fxPackageId === 'string' && skin.fxPackageId);
